import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "tx-pagehead" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "tx-toolbar" }
const _hoisted_4 = {
  key: 0,
  class: "tx-seg",
  role: "tablist"
}
const _hoisted_5 = ["aria-selected"]
const _hoisted_6 = ["aria-selected"]
const _hoisted_7 = { class: "tx-chips" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onSubmit"]
const _hoisted_10 = ["placeholder", "aria-label"]
const _hoisted_11 = { class: "tx-card tx-card--flush" }
const _hoisted_12 = {
  key: 1,
  class: "tx-table"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("th", null, "#", -1 /* HOISTED */)
const _hoisted_14 = { class: "tx-hide-sm" }
const _hoisted_15 = { class: "tx-hide-sm" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "tx-mono" }
const _hoisted_18 = ["href"]
const _hoisted_19 = { class: "tx-muted tx-block" }
const _hoisted_20 = { class: "tx-hide-sm" }
const _hoisted_21 = {
  key: 0,
  class: "tx-center"
}
const _hoisted_22 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", null, _toDisplayString($setup.state.t("tickets.title")), 1 /* TEXT */),
      _createElementVNode("a", {
        href: $setup.link('tickets/new'),
        "data-nav": "",
        class: "tx-btn tx-btn--primary"
      }, [
        _createVNode($setup["Icon"], {
          name: "plus",
          size: "16"
        }),
        _createTextVNode(_toDisplayString($setup.state.t("tickets.new")), 1 /* TEXT */)
      ], 8 /* PROPS */, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      ($setup.can('tickets.organization'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("button", {
              role: "tab",
              "aria-selected": $setup.scope === 'own',
              class: _normalizeClass({ on: $setup.scope === 'own' }),
              onClick: _cache[0] || (_cache[0] = $event => ($setup.setScope('own')))
            }, _toDisplayString($setup.state.t("tickets.mine")), 11 /* TEXT, CLASS, PROPS */, _hoisted_5),
            _createElementVNode("button", {
              role: "tab",
              "aria-selected": $setup.scope === 'organization',
              class: _normalizeClass({ on: $setup.scope === 'organization' }),
              onClick: _cache[1] || (_cache[1] = $event => ($setup.setScope('organization')))
            }, _toDisplayString($setup.state.t("tickets.org")), 11 /* TEXT, CLASS, PROPS */, _hoisted_6)
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.STATUSES, (s) => {
          return _createElementVNode("button", {
            key: s.value,
            class: _normalizeClass(["tx-filter", { on: $setup.status === s.value }]),
            onClick: $event => ($setup.setStatus(s.value))
          }, _toDisplayString($setup.state.t(s.label)), 11 /* TEXT, CLASS, PROPS */, _hoisted_8)
        }), 64 /* STABLE_FRAGMENT */))
      ]),
      _createElementVNode("form", {
        class: "tx-search",
        role: "search",
        onSubmit: _withModifiers($setup.reload, ["prevent"])
      }, [
        _createVNode($setup["Icon"], {
          name: "search",
          size: "16"
        }),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.search) = $event)),
          type: "search",
          placeholder: $setup.state.t('tickets.search_ph'),
          "aria-label": $setup.state.t('common.search')
        }, null, 8 /* PROPS */, _hoisted_10), [
          [
            _vModelText,
            $setup.search,
            void 0,
            { trim: true }
          ]
        ])
      ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_9)
    ]),
    _createVNode($setup["Loader"], {
      loading: $setup.loading && !$setup.rows.length,
      error: $setup.error,
      onRetry: $setup.reload
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          (!$setup.rows.length)
            ? (_openBlock(), _createBlock($setup["Empty"], {
                key: 0,
                icon: "ticket"
              }))
            : (_openBlock(), _createElementBlock("table", _hoisted_12, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_13,
                    _createElementVNode("th", null, _toDisplayString($setup.state.t("tickets.subject")), 1 /* TEXT */),
                    _createElementVNode("th", _hoisted_14, _toDisplayString($setup.state.t("tickets.priority")), 1 /* TEXT */),
                    _createElementVNode("th", _hoisted_15, _toDisplayString($setup.state.t("tickets.sla_resolution")), 1 /* TEXT */),
                    _createElementVNode("th", null, _toDisplayString($setup.state.t("common.status")), 1 /* TEXT */)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.rows, (t) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: t.name,
                      class: "tx-clickable",
                      onClick: $event => ($setup.open(t))
                    }, [
                      _createElementVNode("td", _hoisted_17, _toDisplayString(t.name), 1 /* TEXT */),
                      _createElementVNode("td", null, [
                        _createElementVNode("a", {
                          href: $setup.link('tickets/' + t.name),
                          "data-nav": "",
                          class: "tx-strong"
                        }, _toDisplayString(t.subject), 9 /* TEXT, PROPS */, _hoisted_18),
                        _createElementVNode("small", _hoisted_19, [
                          _createTextVNode(_toDisplayString($setup.fmtDate(t.modified, true)) + " ", 1 /* TEXT */),
                          ($setup.scope === 'organization' && !t.is_mine)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(" · " + _toDisplayString($setup.state.t("tickets.org")), 1 /* TEXT */)
                              ], 64 /* STABLE_FRAGMENT */))
                            : _createCommentVNode("v-if", true)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_20, _toDisplayString(t.priority || "—"), 1 /* TEXT */),
                      _createElementVNode("td", {
                        class: _normalizeClass(["tx-hide-sm", { 'tx-danger': t.overdue }])
                      }, _toDisplayString(t.resolution_by ? $setup.fmtDate(t.resolution_by, true) : "—"), 3 /* TEXT, CLASS */),
                      _createElementVNode("td", null, [
                        _createVNode($setup["Badge"], {
                          status: t.overdue ? 'Overdue' : t.status_category,
                          label: t.status
                        }, null, 8 /* PROPS */, ["status", "label"])
                      ])
                    ], 8 /* PROPS */, _hoisted_16))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]))
        ]),
        ($setup.rows.length < $setup.total)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("button", {
                class: "tx-btn tx-btn--ghost",
                disabled: $setup.loading,
                onClick: $setup.more
              }, _toDisplayString($setup.state.t("common.view_all")) + " (" + _toDisplayString($setup.rows.length) + " " + _toDisplayString($setup.state.t("common.of")) + " " + _toDisplayString($setup.total) + ") ", 9 /* TEXT, PROPS */, _hoisted_22)
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["loading", "error"])
  ]))
}